import React from 'react';
import { Box } from '@mui/material';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PhoneContainer from './PhoneContainer';
// import Grid from '@mui/material/Unstable_Grid2';

export default function HomePage() {
  const theme = useTheme();

  const homeContainerStyle = {
    textAlign: 'left',
    width: '100vw',
    marginLeft: 'auto',
    marginRight: 'auto',
    backgroundColor: theme.palette.primary.light
  };

  return (
    <Box sx={homeContainerStyle} data-testid='home-container' >

      {/* <Box sx={{ textAlign: 'center', padding: '20px', paddingBottom: '0px', width: '100vw', marginLeft: 'auto', marginRight: 'auto' }}>
        <Typography variant='h3'>
          Gridvault Demo
        </Typography>
      </Box> */}
      <Box sx={{ textAlign: 'left', padding: '20px', paddingTop: '0px', width: '100vw', marginLeft: 'auto', marginRight: 'auto' }}>
        <PhoneContainer />
      </Box>

    </Box >
  );
}


